import { defineField, defineType } from 'sanity'
import { strongEmLink } from '../../data/richText'

export default defineType({
  title: 'Contact block',
  name: 'contactBlock',
  type: 'object',
  fields: [
    defineField({
      title: 'Theme',
      name: 'theme',
      type: 'string',
      options: {
        list: [
          { title: 'Default (white bg, dark text)', value: 'default' },
          { title: 'Dark (dark bg, white text)', value: 'dark' },
          { title: 'Brand (red bg, white text)', value: 'brand' },
        ],
      },
      initialValue: 'default',
      description: 'Background & text colors.',
    }),
    defineField({
      title: 'Title',
      name: 'name',
      type: 'string',
    }),
    defineField({
      title: 'Content',
      name: 'content',
      type: 'array',
      of: strongEmLink,
    }),
    defineField({
      title: 'Desktop BG',
      name: 'bgDesktop',
      type: 'image',
      description:
        'Object must be left aligned covering the maximum of 50% of the image width',
      options: {
        hotspot: true,
      },
    }),
    defineField({
      title: 'Mobile BG',
      name: 'bgMobile',
      type: 'image',
      options: {
        hotspot: true,
      },
      description:
        'Object must be bottom aligned covering the maximum of 50% of the image height',
    }),
    defineField({
      title: 'Button',
      name: 'button',
      type: 'link',
    }),
  ],
})
